export default __webpack_public_path__ + "static/media/img-training.58252737.png";